import {FC, useCallback} from 'react';
import './EmojiBar.less';
import IconButton, {ICONS, IconTypeItem} from "../IconButton/IconButton";

const icons = ICONS.filter(icon => icon.tags?.includes('emoji'));

const EmojiBar: FC<EmojiBarProps> = props => {
    const onChange = useCallback((icon: IconTypeItem) => {
        // Clone the current values
        const values = new Set(props.values);

        // Adding or removing?
        const adding = !values.has(icon.name);
        if (adding) values.add(icon.name);
        else values.delete(icon.name);

        props.onChange(Array.from(values.keys()));
    }, [props]);

    return (
        <div className={`emoji-bar ${props.smallView ? 'small' : ''}`}>
            {icons.sort((a, b) => a.level - b.level)
                  .map(icon => {
                      const disabled = !props.values.includes(icon.name);
                      const show = props.smallView ? !disabled : true;

                      return show ?
                          <IconButton className='emoji'
                                      key={icon.name}
                                      type={icon}
                                      color={!disabled ? icon.color : 'grey'}
                                      onClick={props.smallView ? null : () => onChange(icon)}
                          /> : null
                      })}
        </div>
    );
}

export type EmojiBarProps = {
    onChange: Function,
    values: string[],
    smallView?: boolean
};

export default EmojiBar;